<!--
  -  Copyright (c) Qwoach LLC 2025. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush on 01/27/2026
  -->

<template>
	<el-slider
		v-model="valueData"
		v-bind="attrsVue2"
		:disabled="disabled"
		@update:modelValue="onInput"
		@change="notifyValueChanged"/>
</template>

<script>
import BaseVModelView from "@/core/components/BaseVModelView.vue";

export default {
	name: "qw-slider",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		disabled: {Boolean, default: false},
	},

	methods: {
		onInput(value){
			this.$emit('update:modelValue', value)
		}
	}
}
</script>

<style lang="scss">
</style>
